import React, { useEffect, useState } from "react";
import { User, Lock, ArrowLeftCircle } from "react-feather"; // react-feather icons
import logo from "../assets/images/logo.png";
import { useNavigate, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiPublic from "./ApiNoToken";

function Forgot() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // biar tidak reload halaman
    // TODO: tambahkan validasi login (misalnya cek username/password)
    // Validasi domain email
    const allowedDomains = ["gmail.com", "yahoo.com"];
    const emailValue = formData.email.trim();
    const domain = emailValue.split("@")[1]?.toLowerCase();

    if (!domain || !allowedDomains.includes(domain)) {
      toast.error(
        "Email hanya boleh menggunakan domain gmail.com atau yahoo.com."
      );
      return;
    }

    // Cek karakter berbahaya
    const invalidCharPattern = /[<>{}"'`$%^&*+=]/;
    if (invalidCharPattern.test(formData.email)) {
      toast.error("Email tidak boleh mengandung simbol berbahaya.");
      return;
    }

    if (formData.email.trim() === "") {
      toast.warning("Email wajib diisi.");
      return;
    }

    if (formData.email.length > 100) {
      toast.error("Email terlalu panjang (maksimal 100 karakter).");
      return;
    }

    try {
      const res = await apiPublic.post("/forgot-password", {
        email: formData.email,
      });

      console.log("Forgot Password sukses:", res.data);

      // Simpan expired time ke localStorage
      localStorage.setItem("otpExpiredAt", res.data.expired_at);
      localStorage.setItem("resetEmail", formData.email);

      toast.success(res.data.message);
      navigate("/CodeOtp");
    } catch (err) {
      console.error("Forgot Password gagal:", err.response || err);
      toast.error(
        err.response?.data?.message || "Gagal request reset password!"
      );
    }
  };

  return (
    <div id="auth">
      <div className="container">
        <div className="row">
          <div className="col-md-5 col-sm-12 mx-auto">
            <div className="card pt-4">
              <div className="card-body">
                <div className="text-center mb-5">
                  <img src={logo} height="80" className="mb-4" alt="logo" />
                  <h3
                    style={{
                      fontFamily: '"Arial Black", "Arial", sans-serif',
                      fontWeight: "bold",
                      color: "#1a237e", // Biru tua, bisa disesuaikan
                      textTransform: "uppercase",
                      marginBottom: "0.2rem",
                    }}
                  >
                    PERUMDAM TKR
                  </h3>
                  <p
                    style={{
                      fontFamily: '"Arial Black", "Arial", sans-serif',
                      color: "#555555", // Abu-abu gelap
                      textTransform: "uppercase",
                      fontWeight: "normal",
                      fontSize: "0.9rem",
                      marginTop: "0",
                    }}
                  >
                    KABUPATEN TANGERANG
                  </p>
                  <p>
                    Masukkan email Anda untuk mendapatkan tautan reset kata
                    sandi.
                  </p>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="form-group position-relative has-icon-left">
                    <label htmlFor="username">Email</label>
                    <div className="position-relative">
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Masukkan email Anda"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <div className="form-control-icon">
                        <User size={16} />
                      </div>
                    </div>
                  </div>

                  <div className="form-check clearfix my-4">
                    <div className="float-right"></div>
                    <div className="float-left"></div>
                  </div>
                  <div className="clearfix">
                    <button
                      className="btn btn-secondary float-left"
                      type="button"
                      onClick={() => window.history.back()}
                    >
                      <ArrowLeftCircle
                        size={16}
                        style={{ marginRight: "8px" }}
                      />
                      Back
                    </button>
                    <button
                      className="btn btn-primary float-right"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default Forgot;
